import globalResize from '../util/globalResize';

export const DEBUG_MODE = false;
export const IS_DEFAULT_GUI_OPEN = false;
export const BREAK_POINT_SP = 768;
export const BREAK_POINT_PC = 1800;
export let IS_SP = window.innerWidth <= BREAK_POINT_SP ? true : false;
globalResize.addEvent(() => {
  IS_SP = window.innerWidth <= BREAK_POINT_SP ? true : false;
});

export let IS_PORTRAIT = window.matchMedia('(orientation: portrait)').matches;
const mediaQuery = window.matchMedia('(orientation: portrait)');
mediaQuery.addEventListener('change', (event) => {
  IS_PORTRAIT = event.matches;
});

export const EASE_LIST = [
  'linear',
  'sine.in',
  'sine.out',
  'sine.inOut',
  'power1.in',
  'power1.out',
  'power1.inOut',
  'power2.in',
  'power2.out',
  'power2.inOut',
  'power3.in',
  'power3.out',
  'power3.inOut',
  'power4.in',
  'power4.out',
  'power4.inOut',
  'expo.in',
  'expo.out',
  'expo.inOut',
  'back.in',
  'back.out',
  'back.inOut',
  'bounce.in',
  'bounce.out',
  'bounce.inOut',
  'elastic.in',
  'elastic.out',
  'elastic.inOut'
];
